import { render, staticRenderFns } from "./UserPageNotFound.vue?vue&type=template&id=2f0a3bf8&scoped=true&"
import script from "./UserPageNotFound.vue?vue&type=script&lang=js&"
export * from "./UserPageNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0a3bf8",
  null
  
)

export default component.exports